
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { COMPANY_LIST } from "@/constant";
import {
  searchCustomer
} from "@/api/customer";
import {
  abnormalDeliveryPoInfos,
  abnormalDeliveryOverdelivery,
  abnormalDeliveryUnderdelivery,
  getOverDeliveryList,
  abnormalDeliveryInventoryList
} from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";
import ProcessExcessQty
  from "@/views-oms/sales-order-management/order/abnormal-delivery-handling/components/ProcessExcessQty.vue";
import any = jasmine.any;

@Component({
  name: "ModifyQuantity",
  components: {
    ProcessExcessQty,
    Stock: () => import("./Stock.vue")
  }
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "管理交货数量" }) private title: "";
  @Prop({ default: "" }) private poInfoId: string;
  @Prop({ default: "" }) private overUnderageStatus: string;

  @Watch("show", { immediate: true })
  private watchShow() {
    if (this.show && this.poInfoId) {
      this.abnormalDeliveryPoInfos();
    }
  }

  @Watch("number", { immediate: true })
  private watchNumber() {
    this.form.number = this.number;
    this.form.leftNumber = this.getLeftNumber();
  }

  private number = 0;
  private showStock = false;
  private form = {
    customerId: null,
    company: null,
    overdueQuantity: null,
    number: null,
    leftNumber: null,
    useInventoryQuantity: null, // 使用库存数量
    remainingInventoryQuantity: null // 剩余库存数量
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  private Markersloading = false;
  private remainNum = 0;
  private MarkersCol = [
    {
      label: "装箱单号",
      prop: "hqPackingListCode",
      key: "hqPackingListCode",
      show: true,
      disabled: false,
    },
    {
      label: "主包装编号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "主包装类型",
      prop: "inventoryState",
      key: "inventoryState",
      show: true,
      disabled: false,
    },
    {
      label: "含有本产品非库存数量",
      prop: "totalNumberPcs",
      key: "totalNumberPcs",
      show: true,
      disabled: false,
    },
    {
      label: "标记尾差",
      prop: "chooseNumberPcs",
      key: "chooseNumberPcs",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "标记",
          click: "handleAdd"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;
  private MarkersColTrue = [
    {
      label: "装箱单号",
      prop: "hqPackingListCode",
      key: "hqPackingListCode",
      show: true,
      disabled: false,
    },
    {
      label: "主包装编号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "主包装类型",
      prop: "inventoryState",
      key: "inventoryState",
      show: true,
      disabled: false,
    },
    {
      label: "含有本产品非库存数量",
      prop: "totalNumberPcs",
      key: "totalNumberPcs",
      show: true,
      disabled: false,
    },
    {
      label: "标记尾差",
      prop: "chooseNumberPcs",
      key: "chooseNumberPcs",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          click: "handleDelete"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;
  private MarkersList = [] as any;
  private MarkersListCopy = [] as any;
  private MarkersListTrue = [] as any;
  private infoFields = [
    {
      label: "询价参照号",
      key: "inquiryRefNumber"
    },
    {
      label: "号码类型",
      key: "inquiryRefType"
    },
    {
      label: "供应商号码",
      key: "supplierCode"
    },
    {
      label: "华强品名",
      key: "hqProductName"
    },
    {
      label: "Product Name",
      key: "productName"
    }
  ] as any;
  public infoFields2 = [
    {
      label: "接单数量",
      key: "shipmentQuantity"
    },
    {
      label: "下单数量",
      key: "orderQuantity"
    },
    {
      label: "使用库存数量",
      key: "useInventoryQuantity"
    },
    {
      label: "已交货数量",
      key: "allGoodsEnterdQuantity"
    },
    {
      label: "装箱单数量",
      key: "hqPackingListQuantity"
    },
    {
      label: "当前交货数量",
      key: "goodsEnterdQuantity"
    }

  ] as any;
  private infoFields3 = [
    {
      label: "欠发结果",
      key: "overdueQuantity"
    },
    {
      label: "剩余库存数量",
      key: "remainingInventoryQuantity"
    }
  ] as any;
  private infoFields4 = [
    {
      label: "超发结果",
      key: "overdueQuantity"
    },
    {
      label: "剩余库存数量",
      key: "leftNumber"
    },
    {
      label: "存入库存数量",
      key: "number"
    }
  ] as any;
  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change"
      },
      options: COMPANY_LIST
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change"
      },
      labelKey: "abbreviation",
      valueKey: "id"
    }
  ];

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async abnormalDeliveryPoInfos() {
    const res: any = await abnormalDeliveryPoInfos(this.poInfoId);
    this.form = res;
    this.form.overdueQuantity = res.overdueQuantity || 0;
    this.form.number = this.form.overdueQuantity;
      this.number = this.form.overdueQuantity;
    this.form.leftNumber = this.getLeftNumber();
  }

  private getLeftNumber() {
    return Math.abs(this.form.overdueQuantity - this.form.number);
  }

  private async submitForm(): Promise<void> {
    this.$confirm('是否要确认', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (this.overUnderageStatus === "OVERDELIVERY") {
        this.abnormalDeliveryOverdelivery();
      } else {
        this.abnormalDeliveryUnderdelivery();
      }
    })
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }

  private selectInventoryLoading = false;
  private inventories: any[] = [];
  private remainingQty = 0;
  //   使用客人库存
  private async handleStock() {
    this.selectInventoryLoading = true;
    try {
      this.remainingQty =this.form.overdueQuantity;
      const data:any = await abnormalDeliveryInventoryList(this.poInfoId);
      this.inventories = data;
      this.curPoInfoId = this.poInfoId;
      this.showStock = true;
      this.curPoInfoId = this.poInfoId;
    }catch (error) {
      console.error(error);
    }finally {
      this.selectInventoryLoading = false;
    }
  }

  //  使用客人库存数量
  private handleSuccess(list) {
    // 计算 list 中quantity总和
    let quantity = 0;
    list.forEach(item => {
      quantity += item.useInventoryQuantity;
    });
    console.log('this.form.overdueQuantity',this.form.overdueQuantity)
    console.log('quantity',quantity)
    if((Number(this.form.overdueQuantity) - quantity) < 0)  {
      this.$notify({
        title: "提示",
        message: "数量异常！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.number = Number(this.form.overdueQuantity) - quantity;
    this.form.useInventoryQuantity = Number(this.form.useInventoryQuantity) + quantity
    this.form.remainingInventoryQuantity = Number(this.form.remainingInventoryQuantity) - quantity
    this.underList = list;
  }

  private underList = [] as any;

  private async abnormalDeliveryOverdelivery() {
    try {
      await abnormalDeliveryOverdelivery(this.poInfoId, this.MarkersListTrueDeep);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.MarkersListTrueDeep = []
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private showMarkers = false;
  private curPoInfoId = "";
  private remainingMarkQty = 0;
  private markLoading = false;
  private packingList = [];
  private async handleMarkers() {
    this.markLoading = true;
    try {
      let data:any = await getOverDeliveryList(this.poInfoId);
      this.packingList = data;
      this.showMarkers = true;
      this.curPoInfoId = this.poInfoId;
      this.remainingMarkQty = this.form.overdueQuantity;
    }catch (error) {
      console.error(error);
    }finally {
      this.markLoading = false;
    }
    // this.Markersloading = true;
    // this.backupCopyNumber = this.form.overdueQuantity;
    // await getOverDeliveryList(this.poInfoId).then((res:any) => {
    //   this.MarkersList = res
    //   this.MarkersListCopy = deepClone(this.MarkersList)
    //   this.Markersloading = false;
    // }).catch(err => {
    //   console.log(err);
    //   this.Markersloading = false;
    // })
  }
  
  private backupCopyNumber = 0;
  private showMarkersClose() {
    (this.$refs.table as any).$refs.table.clearSelection();
    (this.$refs.tableTrue as any).$refs.table.clearSelection();
    this.form.overdueQuantity = this.backupCopyNumber
    this.showMarkers = false;
  }
  private MarkersListTrueDeep = [] as any;
  private showMarkersSubmit() {
    this.MarkersListTrueDeep = deepClone(this.MarkersListTrue)
    this.MarkersListTrue = []
    this.showMarkers = false;
    this.MarkersListTrueDeep.map(e => {
      this.form.overdueQuantity -= Number(e.chooseNumberPcs)
      this.number += Number(e.chooseNumberPcs)
    })
  }

  // 欠发
  private async abnormalDeliveryUnderdelivery() {
    try {
      await abnormalDeliveryUnderdelivery(this.poInfoId, this.underList);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private dblclickMarkersTrue(row) {
    let newOBJ = deepClone(row.row)
    let index = this.MarkersListTrue.findIndex(e => e.id === newOBJ.id)
    this.form.overdueQuantity = this.form.overdueQuantity + Number(newOBJ.chooseNumberPcs);
    (this.$refs.tableTrue as any).$refs.table.clearSelection();
    this.MarkersListTrue.splice(index,1)
    let findOBJ = this.MarkersListCopy.find(e => e.id === newOBJ.id)
    this.MarkersList.push(findOBJ)
  }

  private dblclickeMarkers (row) {
    if(this.form.overdueQuantity > 0) {
      let newOBJ = deepClone(row.row)
      let index = this.MarkersList.findIndex(e => e.id === newOBJ.id)
      if(this.form.overdueQuantity > newOBJ.totalNumberPcs) {
        newOBJ.chooseNumberPcs = newOBJ.totalNumberPcs
        this.form.overdueQuantity = this.form.overdueQuantity - Number(newOBJ.totalNumberPcs)
        this.MarkersListTrue.push(newOBJ);
        this.MarkersList.splice(index,1)
      } else if (this.form.overdueQuantity < newOBJ.totalNumberPcs) {
        newOBJ.chooseNumberPcs = this.form.overdueQuantity;
        this.MarkersListTrue.push(newOBJ);
        this.form.overdueQuantity = 0;
        this.MarkersList.splice(index,1)
      } else {
        newOBJ.chooseNumberPcs = newOBJ.totalNumberPcs
        this.MarkersListTrue.push(newOBJ);
        this.form.overdueQuantity = 0;
        this.MarkersList.splice(index,1)
      }
    } else {
      this.$notify({
        title: "提示",
        message: "无法标记！",
        type: "warning",
        duration: 2000
      });
    }
  }
  private MarkListSelected = [] as any;
  private MarkListSelectedTrue = [] as any;
  private onSelectionChangeMarkers(rows) {
    this.MarkListSelected = rows
  }

  private onSelectionChangeMarkersTrue(rows) {
    this.MarkListSelectedTrue = rows
  }
  private allMarkers() {
    if(this.MarkListSelected.length > 0) {
      this.MarkListSelected.map(item => {
        let obj = {
          row:item
        }
        this.dblclickeMarkers(obj)
      });
      (this.$refs.table as any).$refs.table.clearSelection();
    } else {
      this.$notify({
        title: "提示",
        message: "请选择数据",
        type: "error",
        duration: 2000
      });
    }
  }

  private allDetele() {
    if(this.MarkListSelectedTrue.length > 0) {
      this.MarkListSelectedTrue.map(item => {
        let obj = {
          row:item
        }
        this.dblclickMarkersTrue(obj)
      });
      (this.$refs.tableTrue as any).$refs.table.clearSelection();
    } else {
      this.$notify({
        title: "提示",
        message: "请选择数据",
        type: "error",
        duration: 2000
      });
    }
  }
  private async markInventorySuccess() {
    this.close();
    this.$emit("success");
  }
}
